import axios from 'axios';

const syncNodeActions = ({ nodeId, actions, type }) => {
  return axios.put(`conversations/builder/${type}s/${nodeId}/actions/sync`, {
    actions
  });
};

export { syncNodeActions };
